export default __webpack_public_path__ + "static/media/B0001.caa0dbc5.png";